import {
  CosmosIconExternalLink,
  CosmosText,
  CosmosTitle,
} from "@cosmos/web-react";
import classNames from "classnames/bind";
import Image from "next/image";
import styles from "./InfoLinkCard.module.css";

const cx = classNames.bind(styles);

export function InfoLinkCard({
  title,
  kicker,
  linkUrl,
  linkLabel,
  imageUrl,
  imageAlt,
}: {
  kicker: string;
  title: string;
  linkUrl: string;
  linkLabel?: string;
  imageUrl: string;
  imageAlt?: string;
}) {
  return (
    <div className={cx("container")}>
      <div className={cx("content")}>
        <div className={cx("header")}>
          <h2 className={cx("title")}>
            {/*
             * NOTE: all links open in new window per client request,
             * vs:
             * target={isExternalLink(link ?? "") ? "_blank" : undefined}
             * rel={isExternalLink(link ?? "") ? "noopener noreferrer" : undefined}
             */}
            <a
              href={linkUrl}
              className={cx("link")}
              target="_blank"
              rel="noopener noreferrer"
            >
              <CosmosTitle
                className={cx("title")}
                tag="span"
                size="xx-small"
                weight="bold"
                appearance="dark"
                clamp={
                  5
                } /* We override this in CSS, using the `--cosmos-title-clamp-length`, but we need to set it to a value here */
              >
                {title}
              </CosmosTitle>
            </a>
          </h2>
          <CosmosText
            className={cx("kicker")}
            tag="p"
            size="xx-small"
            weight="medium"
            appearance="dark"
            kind="subtle"
          >
            {kicker}
          </CosmosText>
        </div>
        {linkLabel && (
          <CosmosText
            className={cx("link-label")}
            tag="span"
            size="small"
            weight="regular"
            appearance="dark"
            kind="subtle"
            clamp={1}
          >
            <CosmosIconExternalLink className={cx("icon")} />
            <span className={cx("link-overflow")}>{linkLabel}</span>
          </CosmosText>
        )}
      </div>
      {imageUrl && (
        <div className={cx("media")}>
          <Image
            className={cx("image")}
            src={imageUrl}
            alt={imageAlt || ""}
            width={138}
            height={144}
          />
        </div>
      )}
    </div>
  );
}
